import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = (email, password) => {
    // Mock authentication
    setUser({ email, name: email.split('@')[0] });
    return true;
  };

  const logout = () => {
    setUser(null);
  };

  const signup = (name, email, password) => {
    // Mock registration
    setUser({ email, name });
    return true;
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, signup }}>
      {children}
    </AuthContext.Provider>
  );
};
